<div class="search-facets-container">
  <app-search-facets-bubble class="search-facets-bubble"
    *ngFor="let facet of facets; trackBy:trackByFacetId" [facet]="facet"
    (removeFacetBubble)="onRemoveFacetBubble($event)"
    (toggleBubbleLock)="onToggleBubbleLock($event)">
  </app-search-facets-bubble>
  <button class="reset-button ins-buttons button-secondary flint"
    (click)="resetFacetBubbles()"
    data-automation-id="reset-filters-btn"
    *ngIf="resetAvailable">
    <span translate class="text">resetFilters</span>
  </button>
</div>
